import { render, staticRenderFns } from "./GiveawayDetails.vue?vue&type=template&id=c2a1b4ce&scoped=true"
import script from "./GiveawayDetails.vue?vue&type=script&lang=js"
export * from "./GiveawayDetails.vue?vue&type=script&lang=js"
import style0 from "./GiveawayDetails.vue?vue&type=style&index=0&id=c2a1b4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a1b4ce",
  null
  
)

export default component.exports